/**
 * Created by PhpStorm.
 * User: shlomy
 * Date: 19/07/2023
 * Time: 13:03
 */
import { mediaCdnReplace } from '../../utils'
import { IDimension } from './types'
import * as cheerio from 'cheerio'

const blockquote_pattern = /<p>\[blockquote_h text='(.*)'\s\]<\/p>/g

export const cleanHtmlString = (str: string) =>
  mediaCdnReplace(str)
    ?.replace(
      blockquote_pattern,
      '<div class="blockquote"><blockquote>$1</blockquote></div>'
    ) // TODO: Remove blockquote workaround based on input from Reshet
    ?.replace(/role=\\"\\"/g, '')
    ?.replace(/&amp;/g, '&') //TODO: HACK: double encoding fix on qdata

export const getNodesFromHtmlText = (html: string) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const $ = cheerio.load(html)
  const cleanedHtml = cleanHtmlString(html)
  const $cleaned = cheerio.load(cleanedHtml)

  // Get all direct children of the body
  const nodes = $cleaned('body').children().toArray()

  // Filter out text nodes (cheerio handles this differently than DOM)
  return nodes.filter(node => node.type === 'tag')
}

export const cleanOutEndingEmptyLines = (html: string) => {
  // Clean out empty lines at the end of the article
  const childNodes = getNodesFromHtmlText(html).reverse()

  if (childNodes.length > 0) {
    while (
      childNodes[0] &&
      childNodes[0]?.type === 'tag' &&
      childNodes[0].name === 'p' &&
      (cheerio.load(childNodes[0]).html() === '' ||
        cheerio.load(childNodes[0]).html() === ' ' ||
        cheerio.load(childNodes[0]).html() === '&nbsp;')
    ) {
      childNodes.splice(0, 1)
    }
  }

  return childNodes.reverse()
}

export const getWidthAndHeightFromEmbedTag = (embedTag: string): IDimension => {
  const widthMatch = embedTag.match(/width="(\d+)"/)
  const heightMatch = embedTag.match(/height="(\d+)"/)

  const dimension: IDimension = {
    width: 640,
    height: 360,
  }

  if (widthMatch) {
    dimension.width = parseInt(widthMatch[1])
  }

  if (heightMatch) {
    dimension.height = parseInt(heightMatch[1])
  }

  return dimension
}
export const embedRegex =
  /\[embed(?:\s+width="\d+"\s+height="\d+")?](.*?)\[\/embed\]/g
